import { Dayjs } from 'dayjs';
import DateRangePicker, { EventHandler } from 'react-bootstrap-daterangepicker';
import '../../../../../../../../sass/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { RangeValue } from 'contexts/TimeSeriesContext';
import { utcDayjs } from 'utils';
import { useContext, useEffect } from 'react';
import { ThemeContext, ThemeContextType } from 'layout';
import styles from './index.module.scss';

const { rangePicker, dark } = styles;

interface CustomDateRangePickerProps {
    onOk: EventHandler,
    range?: RangeValue,
    isCustomDateFn: (date: Dayjs) => string[]
    isInvalidDateFn: (date: Dayjs) => boolean
}

function CustomDateRangePicker({
  onOk, range, isCustomDateFn, isInvalidDateFn,
} : CustomDateRangePickerProps) {
  const { theme } = useContext<ThemeContextType>(ThemeContext);

  useEffect(() => {
    if (theme === 'dark') {
      document.querySelector('.daterangepicker')?.classList.add(dark);
    }
    return () => {
      document.querySelector('.daterangepicker')?.classList.remove(dark);
    };
  }, [theme]);

  useEffect(() => {
    if (range) {
      const inputElement = document.querySelector('[class^="CustomDateRangePicker_rangePicker"]') as HTMLInputElement;
      if (inputElement) {
        inputElement.value = `${utcDayjs(range?.[0]).format('YYYY-MM-DD HH:mm')} ⇁ ${utcDayjs(range?.[1]).format('YYYY-MM-DD HH:mm')}`;
      }
    }
  }, [range]);

  return (
    <DateRangePicker
      onApply={onOk}
      initialSettings={{
        className: 'hello',
        timePicker: true,
        startDate: utcDayjs(range?.[0]).subtract(utcDayjs(range?.[0]).minute() % 5, 'minute').toDate().toISOString(),
        endDate: utcDayjs(range?.[1]).subtract(utcDayjs(range?.[1]).minute() % 5, 'minute').toDate().toISOString(),
        locale: {
          format: 'YYYY-MM-DD HH:mm',
          separator: ' ⇁ ',
        },
        drops: 'up',
        opens: 'left',
        ranges: {
          '30 minutes': [utcDayjs().subtract(30, 'minute').toDate(), utcDayjs().toDate()],
          '1 hour': [utcDayjs().subtract(1, 'hour').toDate(), utcDayjs().toDate()],
          '2 hours': [utcDayjs().subtract(2, 'hour').toDate(), utcDayjs().toDate()],
          '3 hours': [utcDayjs().subtract(3, 'hour').toDate(), utcDayjs().toDate()],
          '24 hours': [utcDayjs().subtract(1, 'days').toDate(), utcDayjs().toDate()],
        },
        timePicker24Hour: true,
        isCustomDate: isCustomDateFn,
        timePickerSeconds: false,
        timePickerIncrement: 5,
        isInvalidDate: isInvalidDateFn,
      }}
    >
      <input
        type="text"
        name="datetimes"
        className={rangePicker}
        style={{
          background: theme === 'dark' ? '#141414' : undefined,
          color: theme === 'dark' ? '#ffffff' : undefined,
          borderColor: theme === 'dark' ? '#424242' : undefined,
        }}
      />
    </DateRangePicker>
  );
}

export default CustomDateRangePicker;
